const GameState = {
	uninitialized: -1,
	playing: 0,
	done: 1,
	results: 2,
};

// TODO: Update font-size based on layout
document.setDefaultFontSize = function() {
	const container = document.getElementById('game-container');
	const containerWidth = container.clientWidth;
	let fontSize = Math.round(20 * containerWidth / 1055);
	document.documentElement.style.setProperty('--default-font-size', `${fontSize}px`);
}

document.setGameContainerSize = function() {
	const width = window.innerWidth;
	const height = window.innerHeight;
	const container = document.getElementById('game-ratio-container');

	if (height < (width * 2.8 / 4)) {
		container.style.width = `${Math.floor(height * 4 / 2.8)}px`;
	} else {
		container.style.width = `${width}px`;
	}
}

document.computeSizes = function() {
	document.setGameContainerSize();
	document.setDefaultFontSize();
}

document.Game = {
	state: GameState.uninitialized,
	currentQuestionIndex: 0,
	questions: [
		{
			question: "Quelle est la prévalence de l’arthrose en France ?",
			choices: [
				{ label: "6 millions de personnes" },
				{ label: "8 millions de personnes" },
				{ label: "10 millions de personnes", valid: true }
			],
			answerDetailed: "L'arthrose est la maladie rhumatismale la plus répandue. Dix millions de Français sont concernés, dont 65 % des plus de 65 ans<sup>1</sup>. La moitié des sujets touchés éprouvent des douleurs au quotidien<sup>2</sup>.",
			reference: "1. Inserm (2012). Arthrose. [en ligne] https://www.inserm.fr/dossier/arthrose/ - consulté le 08.06.2022<br />\n" +
				"2. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Comprendre l’arthrose. Actualités Pharmaceutiques, 55(555), 18-22."
		},
		{
			question: "Que signifie le terme « gonarthrose » ?",
			choices: [
				{ label: "Arthrose de la colonne vertébrale" },
				{ label: "Arthrose de la hanche" },
				{ label: "Arthrose du genou", valid: true },
				{ label: "Arthrose de la main" }
			],
			answerDetailed: "La gonarthrose représente 30% des arthroses et désigne celle du genou<sup>2</sup>.",
			reference: "2. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Comprendre l’arthrose. Actualités Pharmaceutiques, 55(555), 18-22."
		},
		{
			question: "Laquelle de ces affirmations est correcte ?",
			choices: [
				{ label: "L’arthrose est une maladie qui régresse<br />avec l’âge" },
				{ label: "L’arthrose provoque des poussées<br />inflammatoires qui surviennent<br />généralement le matin", valid: true },
				{ label: "L’arthrose est une maladie caractérisée<br />par la rupture d’un ligament" }
			],
			answerDetailed: "L’arthrose ne régresse jamais. Elle provoque en effet des poussées inflammatoires qui correspondent aux épisodes de destruction du cartilage<sup>1,3</sup>.",
			reference: "1. Inserm (2012). Arthrose. [en ligne] https://www.inserm.fr/dossier/arthrose/ - consulté le 08.06.2022<br />\n" +
				"3. Inserm (2022). Bientôt de nouvelles techniques pour « voir » l’arthrose ?. [en ligne] https://www.inserm.fr/actualite/bientot-de-nouvelles-techniques-pour-voir-larthrose/ - consulté le 08.06.2022"
		},
		{
			question: "Quelle partie de l’articulation amortit les chocs ?",
			choices: [
				{ label: "L’os" },
				{ label: "Le cartilage", valid: true },
				{ label: "La membrane synoviale" }
			],
			answerDetailed: "Le cartilage assure le glissement des os et amortit les chocs. L’arthrose est due à la destruction du cartilage<sup>1,2</sup>.",
			reference: "1. Inserm (2012). Arthrose. [en ligne] https://www.inserm.fr/dossier/arthrose/ - consulté le 08.06.2022<br />\n" +
				"2. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Comprendre l’arthrose. Actualités Pharmaceutiques, 55(555), 18-22."
		},
		{
			question: "Par qui l’arthrose doit-elle être diagnostiquée ?",
			choices: [
				{ "label": "Par un proche qui connaît bien la maladie" },
				{ "label": "Par un infirmier qui demande<br/>systématiquement une radiographie" },
				{ "label": "Par un médecin généraliste ou un RHUMATOLOGUE qui procèdent à un examen clinique", "valid": true }
			],
			answerDetailed: "<p>L’arthrose doit être diagnostiquée par un médecin généraliste ou un rhumatologue. Ils écoutent la plainte du patient, effectuent un examen clinique, et prescrivent si besoin une radiographie<sup>2,4</sup>.</p>",
			reference: "2. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Comprendre l’arthrose. Actualités Pharmaceutiques, 55(555), 18-22. <br/>"
				+ "4. SFR (2015). Qu'est-ce que la rhumatologie ? [en ligne] https://public.larhumatologie.fr/quest-ce-que-la-rhumatologie/presentation - consulté 10.06.2022"
		},
		{
			question: "Parmi ces propositions, laquelle n’est pas un facteur de risque de l’arthrose du genou ?",
			choices: [
				{ label: "L’obésité" },
				{ label: "L’hérédité" },
				{ label: "L’activité physique modérée", valid: true },
				{ label: "La ménopause" }
			],
			answerDetailed: "L’obésité, l’hérédité et la ménopause sont des facteurs de risque de l’arthrose<sup>1,5</sup>. La pratique d’une activité physique modérée est en revanche fortement recommandée en dehors des poussées inflammatoires<sup>1</sup>.",
			reference: "1. Inserm (2012). Arthrose. [en ligne] https://www.inserm.fr/dossier/arthrose/ - consulté le 08.06.2022<br />\n" +
				"5. Millán, Marta Martín, and Santos Castañeda. (2013) \"Estrogènes, arthrose et inflammation.\" Revue du rhumatisme 80.4 : 350-356."
		},
		{
			question: "En cas d’arthrose du genou, l’activité physique…",
			choices: [
				{ label: "est fortement déconseillée" },
				{ label: "doit répondre à un programme personnalisé<br />établi par un médecin", valid: true },
				{ label: "est recommandée en cas de poussées<br />inflammatoires" }
			],
			answerDetailed: "L’activité physique est conseillée, en dehors des épisodes inflammatoires. Le médecin tient compte des préférences et de la disponibilité de la personne souffrant d’arthrose, pour définir un programme d’exercices qui lui est adapté<sup>1,6</sup>.",
			reference: "1. Inserm (2012). Arthrose. [en ligne] https://www.inserm.fr/dossier/arthrose/ - consulté le 08.06.2022<br />\n" +
				"6. Stop Arthrose. Les traitements non médicamenteux [en ligne] https://www.stop-arthrose.org/les-traitements-non-medicamenteux - consulté le 08.06.2022"
		},
		{
			question: "Quelle est l'une des mesures non médicamenteuses à mettre en place en cas d'arthrose du genou ?",
			choices: [
				{ label: "Réduire le surpoids en surveillant<br />son alimentation", valid: true },
				{ label: "Renforcer les muscles en portant<br />des charges lourdes" },
				{ label: "Rester debout toute la journée" }
			],
			answerDetailed: "Pratiquer une activité physique modérée en dehors des poussées douloureuses est essentiel en cas d’arthrose du genou, mais il convient également de limiter les facteurs de risque d’aggravation, tels que le surpoids et le port de charges lourdes<sup>1,6</sup>.",
			reference: "1. Inserm (2012). Arthrose. [en ligne] https://www.inserm.fr/dossier/arthrose/ - consulté le 08.06.2022<br />\n" +
				"6. Stop Arthrose. Les traitements non médicamenteux [en ligne] https://www.stop-arthrose.org/les-traitements-non-medicamenteux - consulté le 08.06.2022"
		},
	],
	render() {
		// Hide all game state
		const gameStates = document.getElementsByClassName('game-state');
		for (let i = 0; i < gameStates.length; i++) {
			if (!gameStates[i].classList.contains('hidden')) {
				gameStates[i].classList.add('hidden');
			}
		}
		// Call method to prepare everything then display the current state
		switch (this.state) {
			case GameState.playing:
				this.renderCurrentQuestion();
				document.getElementById('state-playing').classList.remove('hidden')
				break;
			case GameState.done:
				document.getElementById('state-done').classList.remove('hidden')
				break;
			case GameState.results:
				this.renderCurrentAnswer();
				document.getElementById('state-results').classList.remove('hidden')
				break;
		}
	},
	renderCurrentQuestion() {
		// Reset
		document.getElementById("state-playing-success").innerHTML = "";
		document.getElementById("state-playing-answer").innerHTML = "";
		document.getElementById("state-playing-ref").innerHTML = "";

		// Show current question
		const question = this.questions[this.currentQuestionIndex];

		const questionDiv = document.getElementById("state-playing-question");
		questionDiv.innerHTML = question.question;

		const choicesDiv = document.getElementById("state-playing-choices");
		let choicesHtml = "";
		question.choices.forEach((choice, i) => {
			choicesHtml += `<div class="choice"
				id="choice-${i}"
				onclick="Game.answer(${i})"
			>${choice.label}</div>`;
		});
		choicesDiv.innerHTML = choicesHtml;
	},
	ongoingAnswer: false,
	answer(index) {
		if (this.ongoingAnswer) return;
		this.ongoingAnswer = true;

		const question = this.questions[this.currentQuestionIndex];
		const isValid = !!question.choices[index].valid;

		const validIndex = question.choices.findIndex(v => v.valid);

		// Color valid answer
		const validChoice = document.getElementById("choice-" + validIndex);
		validChoice.classList.add("valid");

		if (!isValid) { // Color selected answer if !valid
			const selectedChoice = document.getElementById("choice-" + index);
			selectedChoice.classList.add("error");
		}

		// Show answer
		document.getElementById("state-playing-success").innerHTML = isValid ? "Exact !" : "Faux !";
		document.getElementById("state-playing-answer").innerHTML = question.answerDetailed;
		document.getElementById("state-playing-ref").innerHTML = `Références:<br/>${question.reference}`;

		const next = () => {
			this.ongoingAnswer = false;
			this.next();
			document.removeEventListener("click", next);
		};
		setTimeout(() => {
			document.addEventListener("click", next);
		}, 100)
	},
	restart() {
		this.currentQuestionIndex = 0;
		this.state = GameState.playing;
		this.render();
	},
	next() {
		this.currentQuestionIndex += 1;
		if (this.currentQuestionIndex === this.questions.length) {
			this.state = GameState.done;
		}
		this.render();
	},
	renderCurrentAnswer() {
		document.getElementById("footer-previous").classList = this.currentQuestionIndex === 0 ? 'hidden' : '';
		document.getElementById("footer-next").classList = this.currentQuestionIndex === this.questions.length - 1 ? 'hidden' : '';
		// Show current question
		const question = this.questions[this.currentQuestionIndex];

		const questionDiv = document.getElementById("state-results-question");
		questionDiv.innerHTML = question.question;

		const choicesDiv = document.getElementById("state-results-choices");
		let choicesHtml = "";
		question.choices.forEach((choice, i) => {
			console.log(choice);
			choicesHtml += `<div class="choice ${choice.valid ? 'valid' : ''}"
			>${choice.label}</div>`;
		});
		choicesDiv.innerHTML = choicesHtml;

		// Show answer
		document.getElementById("state-results-success").innerHTML = "Exact !";
		const answerDiv = document.getElementById("state-results-answer");

		answerDiv.innerHTML = question.answerDetailed;
		if (this.currentQuestionIndex === this.questions.length - 1) {
			answerDiv.innerHTML += "<br/><button id=\"footer-restart\" onclick=\"Game.restart()\">Je réessaye</button>";
		}
		document.getElementById("state-results-ref").innerHTML = `Références:<br/>${question.reference}`;

	},
	nextAnswer() {
		this.currentQuestionIndex += 1;
		this.render();
	},
	previousAnswer() {
		this.currentQuestionIndex -= 1;
		this.render();
	},
	seeResults() {
		this.currentQuestionIndex = 0;
		this.state = GameState.results;
		this.render();
	}
}

document.computeSizes();
document.Game.restart();
addEventListener('resize', document.computeSizes);
